import { makeStyles, Text } from '@fluentui/react-components';
import { ErrorIcon } from '@utils-global';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '16px',
  },
  icon: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '24px',
  },
  title: {
    color: '#14141E',
  },
  description: {
    color: '#706F6F',
  },
  listTitle: {
    color: '#14141E',
    marginTop: '24px',
  },
  list: {
    marginLeft: '25px',
  },
  listItem: {
    color: '#706F6F',
  },
});

type Props = {
  title?: string;
  subtitle?: string;
};

export const ErrorFallback = ({ title, subtitle }: Props) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const resolved = t('errorPage.list', { returnObjects: true });
  const list = Array.isArray(resolved) ? resolved : [];

  return (
    <section className={styles.wrapper} aria-label="Error page">
      <ErrorIcon className={styles.icon} aria-hidden="true" />
      <Text weight="bold" size={300} className={styles.title} role="heading">
        {title ?? t('errorPage.title')}
      </Text>
      <Text weight="semibold" size={300} className={styles.description}>
        {subtitle ?? t('errorPage.subtitle')}
      </Text>

      <Text weight="semibold" size={300} className={styles.listTitle}>
        {t('errorPage.listTitle')}
      </Text>
      <ul className={styles.list}>
        {list.map((listItem) => (
          <li key={listItem}>
            <Text weight="semibold" size={300} className={styles.listItem}>
              {listItem}
            </Text>
          </li>
        ))}
      </ul>
    </section>
  );
};
